import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import S from './DevicesStatusStyles';
import { ThemeType } from '../../../theme/themeType';
import useGetFleetId from '../../../API/hooks/useGetFleetId';
import useGetDeviceStatus from '../../../API/hooks/devices/useGetDeviceStatus';
import DoghnutChartBigWidget from '../../common/DoghnutChartBigWidget/DoghnutChartBigWidget';
import DashboardWidgetMenu from '../DashboardWidgetMenu/DashboardWidgetMenu';
import {
  DeviceStatusDognutConfig,
  DeviceStatusKeys,
} from '../../../API/types/Devices';
import { queryFilterByGroups } from '../../../utils/queryFilters';

const buildDeviceChartConfig = (theme: ThemeType): DeviceStatusDognutConfig => ({
  cards: {
    online: {
      color: theme.charts.deviceOnline,
      label: 'Online',
    },
    offline: {
      color: theme.charts.deviceOffline,
      label: 'Offline',
    },
    unresponsive: {
      color: theme.charts.deviceUnresponsive,
      label: 'Not responding',
    },
  },
  title: 'Devices status',
});

type Props = {
  groupFilters?: Record<string, any>;
  onMove?: () => void;
  onRemove?: () => void;
};

function DevicesStatus({ groupFilters, onMove, onRemove }: Props): JSX.Element {
  const fleetId = useGetFleetId();
  const theme = useTheme() as ThemeType;
  const deviceChartConfig = buildDeviceChartConfig(theme);
  const deviceStatusQuery = `?${queryFilterByGroups(groupFilters)?.slice(1)}`;
  const { data: deviceChartData, isLoading } = useGetDeviceStatus(fleetId, deviceStatusQuery);
  const navigate = useNavigate();
  const handleClick = (): void => {
    navigate('/devices');
  };

  Object.keys(deviceChartConfig.cards).forEach((key): void => {
    deviceChartConfig.cards[key as DeviceStatusKeys]!.count = deviceChartData?.[key as DeviceStatusKeys] || 0;
  });

  return (
    <S.Wrapper>
      <div className="header">
        <h3 className="header-title">Devices Status</h3>
        <DashboardWidgetMenu
          onViewAll={handleClick}
          onMove={onMove}
          onRemove={onRemove}
        />
      </div>
      <div className="devices-status-container">
        <DoghnutChartBigWidget
          percentage
          data={deviceChartConfig}
          loading={isLoading}
          emptyText="No devices to show"
        />
      </div>
    </S.Wrapper>
  );
}

export default DevicesStatus;
